// AUTO-GENERATED by tools/generate-world5.mjs. Do not edit by hand.
// Regenerate with: node tools/generate-world5.mjs
// W5 (Helix) — first paid-tier world. Five colours, wider geometry.
import type { LevelDef } from '@tessera/engine';

export const WORLD_5_GENERATED: LevelDef[] = [
  // d*=5  branching=12.39  D=0.038  tiles=10
  {
    id: 'w5-l01',
    world: 5,
    index: 1,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 7 },
    tiles: [
    { coord: { q: -3, r: 2 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: 0 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: -3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -3 }, color: 0 },
    { coord: { q: 3, r: -1 }, color: 0 },
    { coord: { q: 3, r: -2 }, color: 0 },
    { coord: { q: -3, r: 1 }, color: 1 },
    { coord: { q: -2, r: -1 }, color: 1 },
    { coord: { q: -2, r: 3 }, color: 2 },
    { coord: { q: 2, r: 1 }, color: 2 },
    ],
  },
  // d*=6  branching=16.82  D=0.198  tiles=10
  {
    id: 'w5-l02',
    world: 5,
    index: 2,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 8 },
    tiles: [
    { coord: { q: -1, r: -2 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: 0 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: 1 }, color: 0 },
    { coord: { q: 0, r: 3 }, color: 0 },
    { coord: { q: 1, r: 2 }, color: 0 },
    { coord: { q: -3, r: 2 }, color: 1 },
    { coord: { q: 0, r: -3 }, color: 1 },
    { coord: { q: 2, r: -3 }, color: 2 },
    { coord: { q: 3, r: -1 }, color: 2 },
    ],
  },
  // d*=6  branching=20.64  D=0.287  tiles=11
  {
    id: 'w5-l03',
    world: 5,
    index: 3,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 8 },
    tiles: [
    { coord: { q: 3, r: -1 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 2 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: -3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 0 }, color: 0 },
    { coord: { q: -3, r: 3 }, color: 0 },
    { coord: { q: -3, r: 1 }, color: 0 },
    { coord: { q: 3, r: -2 }, color: 1 },
    { coord: { q: 3, r: 0 }, color: 1 },
    { coord: { q: 3, r: -3 }, color: 1 },
    { coord: { q: 1, r: 2 }, color: 2 },
    { coord: { q: 2, r: 1 }, color: 2 },
    ],
  },
  // d*=6  branching=20.71  D=0.288  tiles=10
  {
    id: 'w5-l04',
    world: 5,
    index: 4,
    radius: 4,
    holes: [],
    objective: { kind: 'clear', moveBudget: 8 },
    tiles: [
    { coord: { q: 4, r: -2 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -4, r: 3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: -3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -4, r: 2 }, color: 0 },
    { coord: { q: -4, r: 4 }, color: 0 },
    { coord: { q: -4, r: 1 }, color: 0 },
    { coord: { q: 4, r: 0 }, color: 1 },
    { coord: { q: 4, r: -1 }, color: 1 },
    { coord: { q: 0, r: 4 }, color: 2 },
    { coord: { q: 1, r: 3 }, color: 2 },
    ],
  },
  // d*=6  branching=21.13  D=0.288  tiles=11
  {
    id: 'w5-l05',
    world: 5,
    index: 5,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 8 },
    tiles: [
    { coord: { q: -2, r: -1 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: 1 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 1, r: 2 }, color: 0 },
    { coord: { q: 3, r: 0 }, color: 0 },
    { coord: { q: 0, r: 3 }, color: 0 },
    { coord: { q: 0, r: -3 }, color: 1 },
    { coord: { q: -1, r: -2 }, color: 1 },
    { coord: { q: -3, r: 0 }, color: 1 },
    { coord: { q: -2, r: 3 }, color: 2 },
    { coord: { q: -1, r: 3 }, color: 2 },
    ],
  },
  // d*=6  branching=21.15  D=0.288  tiles=11
  {
    id: 'w5-l06',
    world: 5,
    index: 6,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 8 },
    tiles: [
    { coord: { q: 2, r: 1 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: -1 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 0 }, color: 0 },
    { coord: { q: 0, r: -3 }, color: 0 },
    { coord: { q: -1, r: -2 }, color: 0 },
    { coord: { q: 1, r: 2 }, color: 1 },
    { coord: { q: 0, r: 3 }, color: 1 },
    { coord: { q: 3, r: 0 }, color: 1 },
    { coord: { q: 2, r: -3 }, color: 2 },
    { coord: { q: 3, r: -3 }, color: 2 },
    ],
  },
  // d*=6  branching=22.12  D=0.294  tiles=11
  {
    id: 'w5-l07',
    world: 5,
    index: 7,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 8 },
    tiles: [
    { coord: { q: 1, r: 2 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: -2 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: -3 }, color: 0 },
    { coord: { q: -2, r: -1 }, color: 0 },
    { coord: { q: -3, r: 0 }, color: 0 },
    { coord: { q: 3, r: 0 }, color: 1 },
    { coord: { q: 0, r: 3 }, color: 1 },
    { coord: { q: 2, r: 1 }, color: 1 },
    { coord: { q: -2, r: 3 }, color: 2 },
    { coord: { q: -3, r: 2 }, color: 2 },
    ],
  },
  // d*=7  branching=16.44  D=0.337  tiles=11
  {
    id: 'w5-l08',
    world: 5,
    index: 8,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 9 },
    tiles: [
    { coord: { q: 1, r: 2 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 0 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: -3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: -3 }, color: 0 },
    { coord: { q: -1, r: -2 }, color: 0 },
    { coord: { q: -2, r: -1 }, color: 0 },
    { coord: { q: 3, r: -3 }, color: 1 },
    { coord: { q: 3, r: -1 }, color: 1 },
    { coord: { q: 0, r: 3 }, color: 1 },
    { coord: { q: -3, r: 3 }, color: 2 },
    { coord: { q: -1, r: 3 }, color: 2 },
    ],
  },
  // d*=7  branching=19.77  D=0.385  tiles=11
  {
    id: 'w5-l09',
    world: 5,
    index: 9,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 9 },
    tiles: [
    { coord: { q: -2, r: 3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 1, r: -3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: 0 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -3 }, color: 0 },
    { coord: { q: 0, r: -3 }, color: 0 },
    { coord: { q: 2, r: -3 }, color: 0 },
    { coord: { q: -1, r: 3 }, color: 1 },
    { coord: { q: -3, r: 3 }, color: 1 },
    { coord: { q: 0, r: 3 }, color: 1 },
    { coord: { q: -3, r: 2 }, color: 2 },
    { coord: { q: -2, r: -1 }, color: 2 },
    ],
  },
  // d*=7  branching=19.93  D=0.419  tiles=11
  {
    id: 'w5-l10',
    world: 5,
    index: 10,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 9 },
    tiles: [
    { coord: { q: 3, r: -1 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 0 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: 3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 3 }, color: 0 },
    { coord: { q: -3, r: 1 }, color: 0 },
    { coord: { q: -3, r: 2 }, color: 0 },
    { coord: { q: 1, r: 2 }, color: 1 },
    { coord: { q: 0, r: 3 }, color: 1 },
    { coord: { q: 3, r: -3 }, color: 1 },
    { coord: { q: 1, r: -3 }, color: 2 },
    { coord: { q: 0, r: -3 }, color: 2 },
    ],
  },
];
